<template>
  <div class="message-view" :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'" :style="positionStyle">
    <transition name="el-message-fade">
      <v-alert dense :text="text" v-show="visible" transition="scale-transition" :type="type">
        {{ message }}
      </v-alert>
    </transition>
  </div>
</template>

<script>
//todo 动画处理
const typeMap = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error',
}
export default {
  name: 'Message',
  data() {
    return {
      visible: false,
      message: '',
      duration: 3000,
      type: 'info',
      iconClass: '',
      customClass: '',
      onClose: null,
      showClose: true,
      closed: false,
      verticalOffset: 70,
      timer: null,
      dangerouslyUseHTMLString: false,
      center: false,
      text: true,
    }
  },

  computed: {
    typeClass() {
      return this.type && !this.iconClass ? `el-message__icon el-icon-${typeMap[this.type]}` : ''
    },
    positionStyle() {
      return {
        top: `${this.verticalOffset}px`,
      }
    },
  },

  watch: {
    closed(newVal) {
      if (newVal) {
        this.visible = false
      }
    },
  },
  methods: {
    handleAfterLeave() {
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    },

    close() {
      this.closed = true
      if (typeof this.onClose === 'function') {
        this.onClose(this)
      }
    },

    clearTimer() {
      clearTimeout(this.timer)
    },

    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          if (!this.closed) {
            this.close()
          }
        }, this.duration)
      }
    },
    keydown(e) {
      if (e.keyCode === 27) {
        // esc关闭消息
        if (!this.closed) {
          this.close()
        }
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.startTimer()
    })
  },
}
</script>

<style scoped lang="scss">
.message-view {
  max-width: 450px;
  position: fixed;
  left: 50%;
  top: 20px;
  transform: translateX(-50%);
}
</style>

<style>
.el-message-fade-enter,
.el-message-fade-leave-active {
  opacity: 0;
  transform: translateY(-100%);
}
</style>

<style lang="scss">
.theme--dark {
  .message-view {
    .v-alert--text:before {
      background-color: #28243d !important;
      border-radius: 0;
      z-index: -1 !important;
      box-shadow: 0 0 4px rgba(114, 108, 108, 0.36) !important;
      opacity: 1;
    }
  }
}
.theme--light {
  .message-view {
    .v-alert--text:before {
      background-color: #ffffff !important;
      border-radius: 0;
      z-index: -1 !important;
      box-shadow: 0 0 4px rgba(114, 108, 108, 0.36) !important;
      opacity: 1;
    }
  }
}
</style>
